export default __webpack_public_path__ + "static/media/icon_small.bc7b90a7.png";